import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MasterModelService } from 'src/app/share/services/master-model/master-model.service';

@Component({
    selector: 'app-vehicle-model',
    templateUrl: './vehicle-model.component.html',
    styleUrls: ['./vehicle-model.component.scss'],
    standalone: false
})
export class VehicleModelComponent implements OnInit {
  addVehicleModelForm: FormGroup;
  makeList: any[] = [];
  responseMsg:string;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly masterModelService: MasterModelService
  ){
    this.addVehicleModelForm = this.formBuilder.group({
      name: ['', [ Validators.required]],
      vehicleMake: ['', [ Validators.required]],
    });
  }

  ngOnInit(): void {
    this.getVehicleMake();
  }

  saveVehicleModel(){
    this.masterModelService.saveModelDetails(this.addVehicleModelForm.value).subscribe((res:any) => {
      this.responseMsg = res.data
    })
  }

  getVehicleMake(){
    this.masterModelService.getMakeDetails().subscribe((res:any) => {
      this.makeList = res.data;
    })
  }
}
